import React from 'react';

import styles from './NoData.module.css';

export const noDataCopy = {
  noCampaign: {
    icon: 'fal fa-search',
    title: 'No Campaign Selected',
    description: 'Select a campaign to see categories.',
  },
  noCategories: {
    icon: `fal fa-ghost ${styles.dark}`,
    title: 'No Active Categories were Found',
    description:
      'Please assign categories to products in this campaign and try again.',
  },
};

const NoData = ({ campaign, isLoading }) => {
  const cause = campaign ? 'noCategories' : 'noCampaign';
  const copy = noDataCopy[cause];
  const { icon, title, description } = copy;

  if (isLoading)
    return (
      <div className={styles.noData}>
        <p>Loading Data...</p>
      </div>
    );

  return (
    <div className={styles.noData}>
      <i className={icon} />
      <p className={styles.title}>{title}</p>
      <p className={styles.description}>{description}</p>
    </div>
  );
};

export default NoData;
